// Module
var code = `<div class="text-info bg-info padding small flex-horizontal">
    <div class="flex-start"><i class="icon-info"></i></div>
    <div>
        <div>Please apply the following so that the Destination server will trust receiving data from this Source server where the task is defined:</div>
        <ul class="margin-top margin-top-sm">
            <li>Download the Server Certificate from this <strong>Source</strong> server (in the
                <a target="_blank" data-bind="attr: { href: certificatesUrl }">Certificates View</a>).
            </li>
            <li>Go to the Certificates View in the <strong>Destination</strong> server and upload that certificate.
            </li>
        </ul>
    </div>
</div>
`;
// Exports
export default code;